module.exports = __webpack_public_path__ + "img/spy.9708d131.svg";